import { render, staticRenderFns } from "./DDList.vue?vue&type=template&id=9223e2ee&scoped=true&"
import script from "./DDList.vue?vue&type=script&lang=js&"
export * from "./DDList.vue?vue&type=script&lang=js&"
import style0 from "./DDList.vue?vue&type=style&index=0&id=9223e2ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9223e2ee",
  null
  
)

export default component.exports